export default "__VITE_ASSET__BbMAuor1__"